import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../../common/models/Error";
import { UserState } from "../../models/UserState";

const getUserDataFailure = (state: UserState, action: PayloadAction<Error>) => {
    state.isLoading = false;
    state.isError = action.payload.error;
}

export default getUserDataFailure;